const evaluateServiceQuality = {
  path: 'evaluateServiceQuality',
  component: resolve => require(['../../../../pages/user/course/evaluateServiceQuality'], resolve)
}

export default evaluateServiceQuality



// WEBPACK FOOTER //
// ./src/router/user/course/evaluateservicequality/index.js